import { render, staticRenderFns } from "./AdminPostTable.vue?vue&type=template&id=54529754&scoped=true&"
import script from "./AdminPostTable.vue?vue&type=script&lang=js&"
export * from "./AdminPostTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminPostTable.vue?vue&type=style&index=0&id=54529754&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54529754",
  null
  
)

export default component.exports